export default class QrServerBuildingRequest {
    public buildingId: string;

    constructor(buildingId: string) {
        this.buildingId = buildingId;
    }

    public toJson(): { buildings: string } {
        return {
            buildings: this.buildingId
        };
    }
}
